<div class="item" layout-horizontal layout-align-items-center>
  <div>
    <div layout layout-align-items-start>
      <span class="icon-container">
        @if (data.disqualifyReason) {
          <rt-icon
            name="block"
            size="small-x"
            [rtTooltip]="
              translations.disqualifyReasonTooltip | translate: { reason: data.disqualifyReason }
            "
            [rtTooltipMaxWidth]="170"
          />
        }
      </span>

      <div class="title" [innerHTML]="title"></div>
    </div>

    @if (!visible) {
      <div margin-top-small-xx>
        <ng-container
          [ngTemplateOutlet]="visibilityTplRef()"
          [ngTemplateOutletContext]="{
            visibility: visibility,
            visible: visible,
          }"
        />
      </div>
    }

    <div class="content">
      @if (hasContent) {
        @switch (kind) {
          @case (QuestionKind.ScaleRating) {
            {{ content }} {{ translations.questions.outOf | translate }}
            {{ ratingScale }}
          }

          @case (QuestionKind.File) {
            @for (attachment of attachments; track attachmentsTrackBy($index, attachment)) {
              <rt-attachment-item
                [attachment]="attachment"
                [hasSetAsCvAction]="canManageCandidates()"
                [translations]="translations.attachmentComponent"
                type="compact-card"
              />
            }
          }

          @case (QuestionKind.Video) {
            <rt-ziggeo-player [token]="content" margin-top-small-x />
          }

          @case (QuestionKind.MultipleChoice) {
            <ng-container
              [ngTemplateOutlet]="contentAnswerTpl"
              [ngTemplateOutletContext]="{ content: multiChoice }"
            />
          }

          @case (QuestionKind.Boolean) {
            <ng-container
              [ngTemplateOutlet]="hasBooleanFlagAnswers() ? booleanAnswerTpl : contentAnswerTpl"
              [ngTemplateOutletContext]="{ content: content }"
            />
          }

          @case (QuestionKind.Legal) {
            <ng-container *ngTemplateOutlet="booleanAnswerTpl" />
          }

          @case (QuestionKind.Date) {
            {{ content | amDateFormat: 'DD MMMM YYYY' }}
          }

          @case (QuestionKind.Salary) {
            {{ content }} {{ currency }}
          }

          @default {
            <ng-container
              [ngTemplateOutlet]="contentAnswerTpl"
              [ngTemplateOutletContext]="{ content: content }"
            />
          }
        }
      }

      @if (!hasContent && visible) {
        <div>
          {{ translations.questions.noAnswer | translate }}
        </div>
      }
    </div>
  </div>
  @if (visible) {
    <div margin-left-auto>
      <ng-container
        [ngTemplateOutlet]="visibilityTplRef()"
        [ngTemplateOutletContext]="{
          visibility: visibility,
          visible: visible,
        }"
      />
    </div>
  }
</div>

<ng-template #booleanAnswerTpl>
  {{
    hasBooleanAnswer
      ? booleanAnswer
        ? (translations.boolean.yes | translate)
        : (translations.boolean.no | translate)
      : visible
        ? (translations.questions.noAnswer | translate)
        : ''
  }}
</ng-template>

<ng-template #contentAnswerTpl let-content="content">
  <span white-space-pre-line>
    @if (content) {
      <rt-link-wrapper [content]="content" />
    } @else {
      {{ translations.questions.noAnswer | translate }}
    }
  </span>
</ng-template>
